import React, { useEffect, useState } from 'react'
import { Button, Input, Spin, Table, Tabs } from 'antd'
import { CiSearch } from 'react-icons/ci'
import { BiSolidPlusCircle } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'

import useDebounce from '../../../hooks/useDebounce'

import {
  createDraftQueue,
  deleteDraftQueue,
  getAllPlayers,
  getDraftQueue,
  setPage,
  setPosition,
  setSearch,
  setSelectedPlayer,
} from '../../../redux/actions/draftAction'

const DraftPool = ({ tableScroll }) => {
  const { allPlayers, position, search, page, limit, tableLoading, draftQueues, activeTab } =
    useSelector((state) => state.draft)
  const { userDetails } = useSelector((state) => state.user)
  const [loading, setLoading] = useState('')

  const dispatch = useDispatch()

  useEffect(() => {
    if (activeTab == 1)
      getData({
        position,
        search,
        limit,
        page,
      })
  }, [position, limit, page, activeTab])

  const getData = async (payload) => {
    await getAllPlayers(payload)
    // await getDraftQueue()
  }

  const handleAddQueue = async (id) => {
    setLoading(id)
    await createDraftQueue({
      team: userDetails?.team?._id,
      player: id,
    })
    setLoading('')
  }

  const handleDeleteQueue = async (playerId, queueId) => {
    setLoading(playerId)
    await deleteDraftQueue(queueId)
    setLoading('')
  }

  const columns = [
    {
      width: 50,
      title: ' ',
      dataIndex: 'plus-icon',
      key: 'plus-icon',
      render: (_, obj) => {
        const isQueue = draftQueues?.find((v) => v?.player?._id === obj?._id)
        return (
          <div>
            {loading === obj?._id ? (
              <Spin />
            ) : isQueue ? (
              <BiSolidPlusCircle
                size={18}
                style={{ marginBottom: '-3px', cursor: 'pointer' }}
                color={'var(--primary)'}
                onClick={() => handleDeleteQueue(obj?._id, isQueue?._id)}
              />
            ) : (
              <BiSolidPlusCircle
                size={18}
                style={{ marginBottom: '-3px', cursor: 'pointer' }}
                onClick={() => handleAddQueue(obj?._id)}
              />
            )}
          </div>
        )
      },
    },
    {
      width: 70,
      title: 'Rank',
      dataIndex: 'Rank',
      key: 'Rank',
      render: (t) => <p>{t || '-'}</p>,
    },
    {
      title: 'Player',
      dataIndex: 'player',
      key: 'player',
      render: (_, obj) => {
        const inj = obj?.InjuryStatus
        return (
          <div className='table_player_name_box nrc_container'>
            <p onClick={() => dispatch(setSelectedPlayer(obj))} style={{ cursor: 'pointer' }}>
              {obj?.Name}{' '}
            </p>{' '}
            <p>
              {obj?.Position} - {obj?.Team}{' '}
            </p>
            {inj === 'Out' ? (
              <>
                <span className='injury_plus'>
                  <b>+</b>
                </span>
                <p className='injury_plus_text'>O</p>
              </>
            ) : inj === 'Questionable' ? (
              <p className='injury_status'>Q</p>
            ) : inj === 'Doubtful' ? (
              <p className='injury_status'>D</p>
            ) : inj === 'Suspended' ? (
              <p className='injury_status'>SSPD</p>
            ) : inj === 'Injured Reserve' ? (
              <p className='injury_status'>IR</p>
            ) : (
              ''
            )}
          </div>
        )
      },
    },
    {
      width: 150,
      title: 'SAM ADP',
      dataIndex: 'adp',
      key: 'adp',
      render: (t) => <p>{t || '-'}</p>,
    },

    {
      width: 150,
      title: '2024 Projected',
      dataIndex: 'projected',
      key: 'projected',
      render: (t) => {
        return <p>{t || '-'}</p>
      },
    },
    {
      width: 150,
      title: '2023 Score',
      dataIndex: 'pf',
      key: 'pf',
      render: (t) => {
        return <p>{t?.toFixed(2) || '-'}</p>
      },
    },
  ]

  return (
    <Table
      loading={tableLoading}
      dataSource={allPlayers?.players}
      columns={columns}
      scroll={tableScroll}
      bordered={false}
      rowKey='_id'
      rowClassName={(_, index) => (index % 2 === 1 ? 'table-row-light' : 'table-row-dark')}
      pagination={{
        pageSize: limit,
        current: page,
        total: allPlayers?.total,
        showSizeChanger: false,
        size: 'default',
        onChange: (page) => {
          dispatch(setPage(page))
        },
      }}
    />
  )
}

export default DraftPool
